<template>
  <div class="illustration-gradients-content" id="identidade-visual-ilustracao-gradientes" data-search-anchor>
    <div class="illustration-gradients-wrapper">
      <h1 class="illustration-gradients-title-span">{{ gradientsTitleSpan }}</h1>
      <h1 class="illustration-gradients-title">{{ gradientsTitle }}</h1>
    </div>

    <p class="illustration-gradients-description">{{ gradientsDescription }}</p>
    <img
      :src="imageSrc"
      alt="Exemplo de gradiente em ilustração"
      class="illustration-gradients-card-item"
      loading="lazy"
    />

    <div class="description-illustration-gradients-wrapper">
      <div v-for="(dont, index) in dontsList" :key="index" class="icon-wrapper">
        <IconCancel />
        <p class="illustration-gradients-two-description">{{ dont }}</p>
      </div>
    </div>
    <img
      :src="gradientsImageSrc"
      alt="Exemplo de gradiente em ilustração - o que não fazer"
      class="illustration-gradients-card-item"
      loading="lazy"
    />
  </div>
</template>

<script lang="ts">
import IconCancel from '@/assets/icons/IconCancel.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import IllustrationPageMixin from '@/mixins/illustration-page-mixin'
import { IllustrationPageStore } from '@/store/visual-identity-page/illustration-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCancel } })
export default class IllustrationGradientsSection extends Mixins(IllustrationPageMixin) {
  illustrationPageStore: PageStoreContract = getModule(IllustrationPageStore, this.$store)

  private readonly pageId = 6

  get gradientsTitleSpan(): string {
    return this.getElementTitle(this.pageId, 0)
  }

  get gradientsTitle(): string {
    return this.getElementText(this.pageId, 0)
  }

  get gradientsDescription(): string {
    return this.getElementText(this.pageId, 1)
  }

  get imageSrc(): string {
    return this.getElementMedia(this.pageId, 2)
  }

  get dontsList(): string[] {
    return [
      this.getElementText(this.pageId, 3),
      this.getElementText(this.pageId, 4),
      this.getElementText(this.pageId, 5),
      this.getElementText(this.pageId, 6)
    ].filter(Boolean)
  }

  get gradientsImageSrc(): string {
    return this.getElementMedia(this.pageId, 7)
  }

  async getIllustrationPage(): Promise<void> {
    await this.illustrationPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.illustrationPageStore.isLoading) {
      await this.getIllustrationPage()
    }
  }
}
</script>

<style lang="scss">
.illustration-gradients-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.illustration-gradients-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.illustration-gradients-title-span,
.illustration-gradients-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.illustration-gradients-title{
  color: #000000;
}

.description-illustration-gradients-wrapper {
  position: relative;
  padding-top: 2rem;

  display: grid;
  grid-template-columns: 50% 50%;
}

.illustration-gradients-description,
.illustration-gradients-two-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;  
}

.illustration-gradients-description {
  margin-top: 0;
  width: 430px;
  white-space: pre-line;
}

.illustration-gradients-two-description { 
  padding-left: 7px;
  width: 378px;
}

.illustration-gradients-card-item {
  position: relative;  
  width: 100%;
  height: 705px;
  object-fit: contain;
  border-radius: 12px;
}

</style>
